<ng-container *ngIf="hasTranslations && bid?.createTranslation">
  <div class="participation-buttons" *ngIf="bid?.isParticipationAccepted === null">
    <button
      class="participation-button"
      nz-button
      nzType="primary"
      nzSize="small"
      [disabled]="isTradingClosed || (isSubmitting$ | async)"
      [nzLoading]="isSubmitting$ | async"
      (click)="updateParticipation(true)"
    >
      {{ 'LOT_INFO.APPROVE_PARTICIPATION' | translate }}
    </button>
    <nz-alert
      *ngIf="isTradingClosed"
      class="participation-notice"
      nzType="warning"
      nzShowIcon
      [nzMessage]="'NEGOTIATIONS.TRADING_CLOSED' | translate"
    ></nz-alert>
  </div>
  <nz-tag *ngIf="bid?.isParticipationAccepted" nzColor="success">
    <i nz-icon nzType="check-circle"></i>
    {{ 'LOT_INFO.PARTICIPATION_ACCEPTED' | translate }}
  </nz-tag>
  <nz-tag *ngIf="bid?.isParticipationAccepted === false" nzColor="warning">
    {{ 'LOT_INFO.PARTICIPATION_CANCELED' | translate }}
  </nz-tag>
</ng-container>
